import { getCurrentEnvironment } from '@general/env';

const transformDataToClickConversionData = data => {
    const { value, target } = data?.click;
    const clickConversionData = { conversion_type: 'click', conversion_label: target, conversion_value: value };

    // Links
    if (value && value.startsWith('http')) {
        if (value.includes('icsc')) {
            clickConversionData.conversion_type = 'internal_link';
            Object.assign(clickConversionData, { outbound: 'false' });
        } else {
            clickConversionData.conversion_type = 'external_link';
            Object.assign(clickConversionData, { outbound: 'true' });
        }

        return clickConversionData;
    }

    // Buttons
    if (target && target.includes('button')) {
        clickConversionData.conversion_type = 'button';
    }

    // Add other click conversions here...

    return clickConversionData;
};

const reduceDataToConversionData = data => {
    let conversionData = {};

    // Click Conversions
    if (data?.click?.type === 'conversion') {
        conversionData = transformDataToClickConversionData(data);
        return conversionData;
    }

    // Search Conversions
    if (data?.search?.type === 'conversion') {
        const { query } = data?.search;
        conversionData = {
            conversion_type: 'search',
            conversion_label: buildPageTitle(data),
            conversion_value: query,
        };

        return conversionData;
    }

    // Pageview Conversions
    conversionData = {
        conversion_type: 'view',
        conversion_label: buildPageTitle(data),
        conversion_value: buildPageLocation(data),
    };

    return conversionData;
};

const buildPageTitle = data =>
    data.app_area ? `${data.app} - ${data.app_area} - ${document.title}` : `${data.app} - ${document.title}`;

const buildPageLocation = data =>
    `https://${data.location?.host}${data.location?.pathname}${data.location?.query_params}`;

export const transformDataToGAFour = data => {
    const { type } = data;
    const env = getCurrentEnvironment();
    let conversionData = {};

    let readyData = {
        send_to: '',
    };

    // console.log('Data before GA4 Transform', data);

    switch (type) {
        case 'view':
            readyData = {
                ...readyData,
                type: 'page_view',
                page_title: buildPageTitle(data),
                page_location: buildPageLocation(data),
            };

            if (data?.app_section) Object.assign(readyData, { app_section: data.app_section });
            break;

        case 'login':
            readyData = {
                ...readyData,
                type: 'login',
                method: 'not_SSO',
            };
            break;

        case 'click':
            readyData = { ...readyData, type: 'click', target: data.click.target, value: data.click.value };
            break;

        case 'conversion':
            conversionData = reduceDataToConversionData(data);
            readyData = { ...readyData, type: 'conversion', ...conversionData };
            break;

        case 'search':
            readyData = { ...readyData, type: 'search', search_term: data.search.query };
            break;

        default:
            if (env !== 'production') {
                console.error('No type for tracking provided. Data not sent to analytics.');
                console.log('trackingData at error:', data);
            }
            break;
    }

    return readyData;
};
